import React, { useMemo, useEffect } from 'react';
import { useData } from '../../contexts/DataContext';
import { Tree, Input, Typography, Spin } from 'antd';
import { useTree } from '../../hooks/useTree';
import { 
  EnvironmentOutlined,
  CloudOutlined, 
  CompassOutlined, 
  BankOutlined, 
  ApiOutlined,
  CiOutlined ,
  DeploymentUnitOutlined,
  CloudDownloadOutlined
} from '@ant-design/icons';


const Channel = () => {
  const { searchValue, onSearch } = useData();
  const { treeData, onSelectSite, loading, error } = useTree();
  const getIcon = (title) => {
    const lowerTitle = title.toLowerCase();
    if (lowerTitle.includes('temperature')) return <EnvironmentOutlined className="text-red-500" />;
    if (lowerTitle.includes('humidity')) return <CloudOutlined className="text-blue-500" />;
    if (lowerTitle.includes('wind')) return <CompassOutlined className="text-green-500" />;
    if (lowerTitle.includes('wave')) return <ApiOutlined className="text-purple-500" />;
    if (lowerTitle.includes('waterLevel')) return <CiOutlined  className="text-cyan-500" />;
    if (lowerTitle.includes('flow')) return <DeploymentUnitOutlined className="text-yellow-500" />;
    if (lowerTitle.includes('precipitation')) return <CloudDownloadOutlined className="text-indigo-500" />;
    return <EnvironmentOutlined className="text-gray-500" />; // Default icon for stations
  };
  useEffect(() => {
    console.log('Search value changed:', searchValue);
  }, [searchValue]);

  if (loading) return <div>Loading sites...</div>;
  if (error) return <div>Error: {error}</div>;

  const onSearchChange = (e) => {
    onSearch(e.target.value);
  };

  const filterTreeData = useMemo(() => {


    if (!searchValue) return treeData;

    const searchLower = searchValue.toLowerCase();
    
    const filteredData = treeData.reduce((acc, station) => {
      const stationMatches = station.title.toLowerCase().includes(searchLower);
      const filteredChildren = station.children.filter(child => 
        child.title.toLowerCase().includes(searchLower)
      );
      
      if (stationMatches || filteredChildren.length > 0) {
        acc.push({
          ...station,
          children: stationMatches ? station.children : filteredChildren
        });
      }
      
      return acc;
    }, []);


    return filteredData;
  }, [treeData, searchValue]);

  useEffect(() => {

  }, [filterTreeData]);

  return (
    <aside className="sidebar">
      <h2 className="text-lg font-semibold p-2">Sites</h2>
      <div className="px-2 pb-4">
        <input 
          type="text" 
          placeholder="Search sites" 
          className="w-full p-2 border rounded-md"
          value={searchValue}
          onChange={onSearchChange}
        />
      </div>
      <Tree
        treeData={filterTreeData}
        onSelect={onSelectSite}
        className="bg-transparent"
        titleRender={(nodeData) => (
          <div className="flex items-center py-1 hover:bg-gray-200 rounded-md transition-colors duration-150">
            <span className="flex items-center mr-2">{getIcon(nodeData.title)}</span>
            <Typography.Text>{nodeData.title}</Typography.Text>
          </div>
        )}
      />
    </aside>
  );
};

export default Channel;